<template>
  <div class="login-layout">
    <div class="form-wrap">
      <h1>AdjustRd Login</h1>
      <img src="/images/login-left.png" class="left-img" />
      <img src="/images/login-right.png" class="right-img" />
      <div class="form">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginLayout'
}
</script>

<style lang="scss">
@import "../assets/style/variables";
@import '../assets/style/_themeify.scss';
@import '../assets/style/login/login';
@include themeify {
  .login-layout {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    .form-wrap {
      width: 536px;
      position: relative;
      h1 {
        height: 35px;
        text-indent: -9999px;
        background: url(themed('logo-url')) no-repeat;
        background-position: center center;
        background-size: auto 54px;
        margin-bottom: 60px;
      }
      .left-img {
        position: absolute;
        left: -600px;
        bottom: -400px;
      }
      .right-img {
        position: absolute;
        left: 360px;
        top: -200px;
      }
      .form {
        background: themed('login-form-background-color');
        padding: 50px 80px;
        box-shadow: themed('login-form-box-shadow');
      }
    }
  }
}
</style>
